import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, PaginationItem } from '@mui/material';

import { getMyNFTs, getMyNFTsBySearch } from '../../../actions/nfts';

import { Link, useLocation } from 'react-router-dom';

const Paginate = ({ page, sort, searchQuery }) => {
  const { numberOfPages } = useSelector((state) => state.nfts);
  const { connectData } = useSelector((state) => state.connect);
  const dispatch = useDispatch();
  const pathname = useLocation().pathname.split('/')[2];

  const pagelink = (itempage)=> {
    if(searchQuery){ 
        return (`/user/${pathname}?searchQuery=${searchQuery}&page=${itempage}&sort=${sort}`)
     }else {
       return (`/user/${pathname}?page=${itempage}&sort=${sort}`)
     }
  }

  useEffect(() => {
    if(searchQuery){
      dispatch(getMyNFTsBySearch({acc:pathname, page:page, sort:sort, searchQuery:searchQuery}));
        }else {
      dispatch(getMyNFTs({acc:pathname, page:page, sort:sort}))
     
    }
  }, [dispatch, page, sort, searchQuery, pathname, connectData]);


  return (
    <Pagination
      count={numberOfPages}
      page={Number(page) || 1}
      variant="outlined"
      color="primary"
      renderItem={(item) => (
        <PaginationItem {...item} component={Link} to={()=>pagelink(item.page)} />
      )}
    />
  );
};

export default Paginate;